import { Box } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { CustomInput } from './styles';
import Currency from '../../assets/svg/currency-yen.svg';
import { t } from 'i18next';

interface InputProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  name: string;
  error?: string;
  type: string;
  placeholder?: string;
  defaultValue?: string;
  disabled?: boolean;
  startAdornment?: boolean;
}

function Input<TFieldValues extends FieldValues = FieldValues>({
  control,
  error,
  name,
  placeholder,
  type,
  disabled,
  defaultValue,
  startAdornment,
}: InputProps<TFieldValues>) {
  return (
    <Controller
      render={({ field }) => (
        <Box sx={{ width: '100%' }}>
          <CustomInput
            id={name}
            variant="outlined"
            fullWidth
            helperText={t(error || '')}
            margin="dense"
            placeholder={placeholder || 'Enter'}
            onChange={(e) => {
              field.onChange(e);
            }}
            value={field.value || ''}
            type={type}
            disabled={disabled}
            inputProps={type === 'number' ? { min: 0 } : undefined}
            InputProps={{
              startAdornment: startAdornment ? <img src={Currency} alt="Currency" width={16} height={16} /> : undefined,
            }}
          />
        </Box>
      )}
      name={name as Path<TFieldValues>}
      control={control}
      defaultValue={defaultValue as any}
    />
  );
}

export default Input;
